<template>
  <vs-popup class="vs-con-loading__container user-edit-popup"
            id="popup"
            title="CREATE USER ROLE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickGroupCreate)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Role Name</small>
                <vs-input v-model="createGroup.name"  name="name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <small class="label">Role Description</small>
              <vs-textarea v-model="createGroup.description" height="100px"/>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ejs-treeview name="tree" id='treeviewcreate'
                            :fields="fields"
                            :showCheckBox='true'
                            :nodeClicked='nodeCheckedCreate'
                            :keyPress='nodeCheckedCreate'
                            :nodeChecked='nodeCheckedCreate'>
              </ejs-treeview>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import Vue from 'vue';
  import {TreeViewPlugin} from "@syncfusion/ej2-vue-navigations";

  Vue.use(TreeViewPlugin);
  const PermissionRepository = RepositoryFactory.get('permissions');
  const RolesRepository = RepositoryFactory.get('roles');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      allPermissions: [],
      dataSource: [],
      createGroup: {},
      fields: {},
      realTimeCheckedNodeCreate: []
    }
  }

  export default {
    name: 'TrackingImagePopUp',
    data() {
      return initialState()
    },
    mixins: [SuccessMessage, ErrorMessages],

    methods: {
      async openPopup() {
        try {
          await Object.assign(this.$data, initialState())
          this.$refs.form.reset();
          this.open = true;
          this.$vs.loading();
          await this.$forceUpdate()
          await this.initialize()
          this.$vs.loading.close()
        } catch (error) {
          this.$vs.loading.close()
        }
      },
      nodeCheckedCreate: function(args) {
        var treeObj = document.getElementById('treeviewcreate').ej2_instances[0];
        this.realTimeCheckedNodeCreate = treeObj.checkedNodes
      },
      async onClickGroupCreate() {

        const vue = this;
        this.$vs.loading();
        try {
          const allPermissionsIds = await this.allPermissions.map((permission) => permission.id);
          this.createGroup.permissions = this.realTimeCheckedNodeCreate.filter(value => allPermissionsIds.includes(Number(value)));
          if (this.createGroup.permissions.length !== 0) {

            // const check_if_selected_rm_supplier_permissions = this.createGroup.permissions
            //   .some(r=> ["65","66", "67", "68", "69", "70", "71", "72", "73"].indexOf(r) >= 0)
            // if(check_if_selected_rm_supplier_permissions) {
            //   this.createGroup.permissions.push("62", "63", "64");
            // }

            this.createGroup.permissions = this.createGroup.permissions.map((x) => {return Number(x)})
            await RolesRepository.createRole(this.createGroup);
            this.showSuccessMessage('New staff group was successfully created!')
            this.open = false;
          } else {
            this.$vs.loading.close();
            this.showErrorMessage('Please select the permissions for the group')
          }
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close();
        await vue.$parent.refreshData()
      },

      async initialize() {
        try {
          const {data} = (await PermissionRepository.get()).data;
          this.allPermissions = data.permissions.map((x) => {
            x.name = x.name.replaceAll('-', ' ')
            return x;
          });
          this.dataSource = data.permission_groups.concat(data.permissions);
          console.log('this.dataSource', this.dataSource);
          this.dataSource = this.dataSource.map((ds) => {
            ds.expanded = !ds.parent_id;
            ds.isChecked = false;
            return ds;
          });
          this.fields = {
            dataSource: this.dataSource,
            id: 'id',
            parentID: 'parent_id',
            text: 'name',
            hasChildren: 'has_child'
          }
        } catch (e) {
        console.log(e.message);
          this.showErrorMessage('Something went wrong!')
        }
      },
      async onClickReset() {
        this.$vs.loading();
        await this.initialize()
        this.createGroup = {}
        this.$vs.loading.close();
      }
    },
    async mounted() {

    },
    components: {
      'v-select': vSelect,
    },
    watch:{
      filteredData (val) {
        this.total = val.length
      }
    },
    computed: {

    },
  }
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }

  .image-wrapper {
    width: 100%;
    height: 75%;
  }
  #treeviewcreate > .e-text-content .e-list-text {
    text-transform: capitalize;
    color: #52e327 !important;
  }

</style>
